import { ConfirmationDialog } from '@optools/components/dialog/confirmation-dialog';
import { Button } from '@optools/components/ui/button';
import { Card } from '@optools/components/ui/card';
import { AnimatePresence, m } from 'motion/react';

export interface BroadcastFormConfirmationProps {
  hidden: boolean;
  loading: boolean;
  onConfirm: () => void;
}

export function BroadcastFormConfirmation({
  hidden,
  loading,
  onConfirm,
}: BroadcastFormConfirmationProps) {
  return (
    <div className="absolute flex w-full justify-center">
      <div className="fixed bottom-0 z-50 w-full sm:max-w-96">
        <AnimatePresence>
          {!hidden && (
            <m.div
              animate={{ transition: { ease: 'easeOut' }, y: -24 }}
              className="w-full"
              exit={{ transition: { ease: 'easeIn' }, y: '100%' }}
              initial={{ y: '100%' }}
              transition={{ duration: 0.2 }}>
              <Card className="rounded-full px-6 pt-2 pb-4">
                <div className="flex flex-col items-center gap-2">
                  <h2 className="text-xs">Save Broadcast Updates?</h2>
                  <div className="grid w-full grid-cols-2 gap-2">
                    <Button
                      className="rounded-l-full"
                      disabled={loading}
                      type="reset"
                      variant="outline">
                      Cancel
                    </Button>
                    <ConfirmationDialog
                      description="Are you sure you want to update the broadcast?"
                      title="Update Broadcast"
                      onConfirm={onConfirm}>
                      <Button
                        className="rounded-r-full"
                        disabled={loading}
                        loading={loading}
                        type="button">
                        Save
                      </Button>
                    </ConfirmationDialog>
                  </div>
                </div>
              </Card>
            </m.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}
